<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1L21 5V11C21 18 12 23 12 23S3 18 3 11V5L12 1Z" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 10L10 12L14 16L18 12" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'IconSecurity'
}
</script>
